export default __webpack_public_path__ + "static/media/mindmap_tsla.2446e46f.png";